<template>
  <div class="grid grid-cols-2 gap-2.5">
    <f7-card raised
      v-for="cat in categories"
      :key="cat.code"
      class="category-card relative overflow-hidden rounded-xl cursor-pointer select-none"
      :class="
        modelValue === cat.code
          ? 'category-card--selected shadow-avocash-sm'
          : 'opacity-90'
      "
      :padding="false"
      role="radio"
      :aria-checked="modelValue === cat.code"
      tabindex="0"
      @click="$emit('update:modelValue', cat.code)"
      @keydown.enter="$emit('update:modelValue', cat.code)"
      @keydown.space.prevent="$emit('update:modelValue', cat.code)"
    >
      <f7-card-content class="category-card-content" :padding="false">
        <f7-badge
          v-if="modelValue === cat.code"
          class="category-card-check bg-primary text-on-primary"
        >
          <f7-icon material="check" :size="14" />
        </f7-badge>
        <div
          class="category-card-icon w-10 h-10 rounded-lg mb-3 display-flex align-items-center justify-content-center"
          :class="
            modelValue === cat.code
              ? 'bg-primary-fixed text-primary'
              : 'bg-surface-container-highest text-on-surface-variant'
          "
        >
          <f7-icon :material="iconMap[cat.icon] || 'style'" :size="24" />
        </div>
        <div class="category-card-title font-label-lg fnt-semibold text-on-surface">
          {{ $t(cat.label) }}
        </div>
        <div class="category-card-desc font-body-sm text-on-surface-variant">
          {{ $t(cat.desc) }}
        </div>
      </f7-card-content>
    </f7-card>
  </div>
</template>

<script setup>
import { GROUP_CATEGORIES } from '../../constants/group-taxonomy.js'

defineProps({ modelValue: { type: String, default: null } })
defineEmits(['update:modelValue'])

const categories = GROUP_CATEGORIES

const iconMap = {
  heart: 'favorite',
  school: 'school',
  'building-church': 'church',
  world: 'public',
  briefcase: 'work',
  'ball-football': 'sports_soccer',
  'hand-heart': 'volunteer_activism',
}
</script>

<style scoped>
.category-card {
  margin: 0;
  box-shadow: none;
  transition: opacity 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.category-card:hover {
  opacity: 1;
}
.category-card:active {
  transform: scale(0.98);
}
.category-card-content {
  position: relative;
  padding: 14px;
}
.category-card-check {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 0;
  padding: 0;
  border-radius: 9999px;
}
.category-card-icon {
  transition: background-color 0.2s ease, color 0.2s ease;
}
.category-card-title {
  font-size: 15px;
  line-height: 1.25;
  margin-bottom: 2px;
}
.category-card-desc {
  font-size: 12px;
  line-height: 16px;
}
</style>
